/**
 * Auth Token Helper
 * Retrieves the authentication token from storage
 */

/**
 * Get the current auth token
 * @returns {string|null}
 */
export function getAuthToken() {
  // Try sessionStorage first (POS/KDS typically use this)
  let token = sessionStorage.getItem('pos_token') || sessionStorage.getItem('token');
  if (token) return token;
  
  // Try localStorage
  token = localStorage.getItem('pos_token') || localStorage.getItem('token');
  if (token) return token;
  
  // Try parsing from stored user object
  try {
    const userData = sessionStorage.getItem('pos_user') || localStorage.getItem('pos_user');
    if (userData) {
      const parsed = JSON.parse(userData);
      if (parsed.token) return parsed.token;
    }
  } catch (e) {
    // Ignore parse errors
  }
  
  // Try cookie (less common)
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'token' || name === 'pos_token') {
      return decodeURIComponent(value);
    }
  }
  
  return null;
}

/**
 * Set auth token in storage
 * @param {string} token 
 * @param {boolean} persistent - Use localStorage instead of sessionStorage
 */
export function setAuthToken(token, persistent = false) {
  const storage = persistent ? localStorage : sessionStorage;
  storage.setItem('token', token);
}

/**
 * Clear auth token from storage
 */
export function clearAuthToken() {
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('pos_token');
  localStorage.removeItem('token');
  localStorage.removeItem('pos_token');
}

/**
 * Get merchant/branch context from storage
 * @returns {Object|null} { merchantId, branchId }
 */
export function getStoredContext() {
  try {
    // Try pos_user first
    const userData = sessionStorage.getItem('pos_user') || localStorage.getItem('pos_user');
    if (userData) {
      const parsed = JSON.parse(userData);
      if (parsed.restaurant_id || parsed.merchant_id) {
        return {
          merchantId: String(parsed.merchant_id || parsed.restaurant_id),
          branchId: String(parsed.branch_id || parsed.restaurant_id),
        };
      }
    }
    
    // Try separate keys
    const merchantId = sessionStorage.getItem('merchant_id') || localStorage.getItem('merchant_id');
    const branchId = sessionStorage.getItem('branch_id') || localStorage.getItem('branch_id');
    
    if (merchantId) {
      return {
        merchantId,
        branchId: branchId || merchantId,
      };
    }
  } catch (e) {
    // Ignore parse errors
  }
  
  return null;
}
